import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Div,
  Input,
  Text
} from 'ui'
import { isValid } from 'ui/Input/validators'
import ResendCode from '../ResendCode'
import useResponsive from 'utils/hooks/useResponsive'


const FormCode = ({
  onSubmit,
  mobileNumber,
  error: customError,
  isLoading,
  textCTA,
  title
}) => {

  const { t } = useTranslation()
  const { isMobile } = useResponsive()

  const [code, setCode] = useState('')
  const [error, setError] = useState(customError || '')

  const isCodeEmpty = !code.replaceAll('_', '')

  const handleChangeCode = (value) => {
    setCode(value)
    setError('')
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!isValid.smsCode(code)) {
      setError(t('codeInvalid'))
      return
    }

    onSubmit({ code })
  }

  useEffect(() => {
    setError(customError)
  }, [customError])

  return (
    <Div
      as='form'
      onSubmit={handleSubmit}
      width='100%'
      flexGrow={1}
      paddingBottom={isMobile ? 100 : 35}
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      whiteSpace='pre-line'
    >

      <div>
        <Text size='xl' align='center' color='headline'>
          {title}
        </Text>

        <Div
          alignSelf='center'
          margin='0 auto'
          marginTop={32}
          maxWidth={350}
        >
          <Input.Code
            value={code}
            onChange={handleChangeCode}
            error={error}
          />
        </Div>

        <Div marginTop={18} marginBottom={24}>
          <ResendCode mobileNumber={mobileNumber} />
        </Div>
      </div>

      <Button
        size='large'
        isFull
        isLoading={isLoading}
        disabled={isCodeEmpty}
      >
        {textCTA}
      </Button>
    </Div>
  )
}

export default FormCode